import type { ExtendedDataGridProps } from './types';

const commonColumnsConfig: Partial<ExtendedDataGridProps['columns'][0]> = {
  disableColumnMenu: true,
  flex: 1,
  hideSortIcons: true,
  filterable: false,
};

export const useDataGridColumns = (columns: ExtendedDataGridProps['columns']) =>
  columns.map((column) => ({
    ...commonColumnsConfig,
    ...column,
  }));
